import { Steps, type StepsValues } from '../constants';

// Personal Information (5 steps)
const PI = {
  min: 0,
  step: 1 / 5, // (5 steps)
};
// Experience and Qualifications (6 steps)
const EQ = {
  min: PI.min + 1,
  step: 1 / 6, // (6 steps)
};
// Business Activity (Step 4)
const BA = {
  min: EQ.min + 1,
  step: 1 / 4, // (Step 4)
};

// prettier-ignore
const map = {
  [Steps.QUESTIONNAIRE_INSTRUCTIONS]: 0,
  // Personal Information (5 steps)
  [Steps.PREVIOUS_NAMES_QUESTION]:                 PI.min,
  [Steps.PREVIOUS_NAMES_FORM]:                     PI.min + PI.step,
  [Steps.CIVIL_SERVICE_EXPERIENCE_QUESTION]:       PI.min + PI.step * 2,
  [Steps.CIVIL_SERVICE_EXPERIENCE_UNAVAILABLE]:    PI.min + PI.step * 2,
  [Steps.RGS_EMPLOYEE_RELATIVES_QUESTION]:         PI.min + PI.step * 3,
  [Steps.RGS_EMPLOYEE_RELATIVES_FORM]:             PI.min + PI.step * 4,
  // Experience and Qualifications (6 steps)
  [Steps.PROFESSIONAL_EDUCATION_QUESTION]:         EQ.min,
  [Steps.PROFESSIONAL_EDUCATION_FORM]:             EQ.min + EQ.step,
  [Steps.INSURANCE_AGENT_EXPERIENCE_QUESTION]:     EQ.min + EQ.step * 2,
  [Steps.INSURANCE_AGENT_EXPERIENCE_LIST_FORM]:    EQ.min + EQ.step * 3,
  [Steps.INSURANCE_AGENT_EXPERIENCE_DETAILS_FORM]: EQ.min + EQ.step * 3,
  [Steps.OTHER_WORK_EXPERIENCE_QUESTION]:          EQ.min + EQ.step * 4,
  [Steps.OTHER_WORK_EXPERIENCE_FORM]:              EQ.min + EQ.step * 5,
  // Business Activity (Step 4)
  [Steps.LEGAL_ENTITY_FOUNDER_STATUS_QUESTION]:    BA.min,
  [Steps.LEGAL_ENTITY_FOUNDER_STATUS_FORM]:        BA.min + BA.step,
  [Steps.SELF_EMPLOYMENT_STATUS_QUESTION]:         BA.min + BA.step * 2,
  [Steps.SELF_EMPLOYMENT_STATUS_FORM]:             BA.min + BA.step * 3,
  // Results
  [Steps.QUESTIONNAIRE_RESULTS]: 3,
};

export const getProgress = (step: StepsValues) => {
  return map[step];
};
